import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 15 * 60);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="fixed top-0 left-0 w-full bg-black text-white py-2 z-50 shadow-md text-center font-bold text-sm md:text-base flex justify-center items-center gap-2" data-id="element-74">
      <Clock className="w-4 h-4 text-yellow-400" data-id="element-75" />
      <span data-id="element-76">
        OFERTA POR TIEMPO LIMITADO:{' '}
        <span className="text-yellow-400 font-mono text-lg" data-id="element-77">
          {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
        </span>
      </span>
      <span className="hidden md:inline text-red-500 font-extrabold ml-2" data-id="element-78">
        🔥 CUPOS DIGITALES LIMITADOS
      </span>
    </div>;
}